<style scoped lang="sass">
#tray-outer
  position: absolute
  top: 0
  left: 0
  height: 100vh
  width: 100vw
  z-index: 2

  #tray
    position: absolute
    top: calc(var(--navigation-height) + var(--status-bar-height))
    left: 0
    height: calc(100vh - var(--navigation-height) - var(--status-bar-height))
    width: 90%
    background-color: var(--dark-gray)
    overflow: auto
</style>
<template>
  <div id="tray-outer" v-on:click.self.prevent="handleClose">
    <div id="tray">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LeftSideTray',
  props: {
    handleClose: {
      type: Function,
      required: true
    }
  }
}
</script>
